var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(this.simulationStarted),expression:"this.simulationStarted"}],staticClass:"simulationInfo"},[_vm._v(" 在网: "+_vm._s(this.vehicleCount)+"辆 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }